function Card(props) {
  const { variant, extra, children,  onClick, ...rest } = props;
  return (
    <div
      onClick={onClick}
      className={`!z-5 relative flex flex-col rounded-[20px] !bg-[#192242] bg-clip-border text-white shadow-none shadow-shadow-500 ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
